import Crud from '../components/UserGroups/Crud'
import Entity from '../components/UserGroups/Add'
import GroupUsers from '../components/UserGroups/GroupUsers'

let routes = {
    path: '/users_groups',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/users_groups/add',
            name: 'Novo Grupo de Usuários',
            component: Entity
        },
        {
            path: '/users_groups/edit/:id?',
            name: 'Editar Grupo de Usuários',
            component: Entity
        },
        {
            path: '/users_groups/groupUsers/:id?',
            name: 'Editar Usuários do Grupo',
            component: GroupUsers
        },
        {
            path: '/users_groups',
            name: 'Grupo de Usuários',
            component: Crud
        },
    ]
};  

export default routes


// WEBPACK FOOTER //
// ./src/router/usergroups.js